import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../login/auth.service';
import { Filter } from '../../../helpers/tableview';

@Injectable()
export class AdsService {

    private headers: Headers;
    private url = environment.apiUrl;

    constructor(private http: Http, private authService: AuthService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    public getAds(filter: Filter): Promise<any> {
        return this.http
          .post(this.url+'/admin/ads', filter, {headers: this.headers})
          .toPromise()
          .then(res => { return {items: res.json().ads, total: res.json().total}})
          .catch(this.handleError);
    }

    public update(adID: number, ad_spent_net: number, cpv_gross : number): Promise<any> {
      const body = {
        ad_spent_net: ad_spent_net,
        cpv_gross: cpv_gross,
      }

      return this.http
        .patch(this.url+'/admin/ads/'+adID, body, {headers: this.headers})
        .toPromise()
        .catch(this.handleError);
  }

    public approve(adID: number, approvedDevices: Array<any>, ad_spent_net: number, cpv_gross : number): Promise<any> {
        let devices = new DeviceList
        devices.devices = []
        approvedDevices.forEach(element => {
          devices.devices.push(parseInt(element, 10))
        });
        devices.ad_spent_net = ad_spent_net
        devices.cpv_gross = cpv_gross

        return this.http
          .post(this.url+'/admin/ads/'+adID+'/approve', devices, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    public reject(adID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/ads/'+adID+'/reject', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    public flag(adID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/ads/'+adID+'/flag', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    public invoice(adID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/ads/'+adID+'/send_invoice', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
      console.error('An error occurred', error);
      return Promise.reject(error.message || error);
    }
}


export enum AdStatus {
  pending = 1,
  approved,
  rejected
}

export class DeviceList {
  public devices : Array<number>
  public ad_spent_net: number
  public cpv_gross : number
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/approval/ads.service.ts